import { getGlobalStates } from "userful-chronos-app-common-js/dist/globalstates/globalStates";
import { StringID } from "userful-chronos-app-common-js/dist/models/common";
import { GcmUserPermission } from "userful-chronos-app-common-js/dist/models/gcm-user-permission";
import { UserfulSearchBar } from "userful-chronos-common-ui/dist";
import { ClickAndDragZone } from "userful-chronos-common-ui/dist/elements";
import EmptyPlaceholder from "../../common/components/placeholders/EmptyPlaceholder";
import { convertKeycloakGroupToTable } from "../../common/components/UserfulTable/UserfulTableConverter";
import UserfulTable from "../../common/Table2026/UserfulTable2026";
import { KeycloakGroup, KeycloakUser, UserfulGroup, UserfulUser } from "../../model/CarbonExternalModels";
import { AppSliceActions } from "../../store/app/appSlice";
import {
    selectSearchInput,
    selectUserGroupFilters,
    useCarbonDispatch,
    useCarbonSelector,
} from "../../store/carbonStore";
import { filterUserGroups } from "../../store/filters/filtersManager";
import { FiltersActions } from "../../store/filters/filtersSlice";
import GroupForm from "./UserGroupForm";

interface IProps {
    groups: { [id: string]: UserfulGroup };
    users: { [id: string]: UserfulUser };
}

export default function UserGroupsTable(props: IProps) {
    const dispatch = useCarbonDispatch();
    const ZONE_ID = "user-groups-table";

    const permissions: GcmUserPermission = getGlobalStates().gcmUserPermission;

    // console.warn(props.groups);

    // Filtering
    const constellationFilters = useCarbonSelector(selectUserGroupFilters);
    const searchInput = useCarbonSelector(selectSearchInput);

    // Data
    const allGroups: KeycloakGroup[] = [];
    for (const property in props.groups) {
        allGroups.push(props.groups[property].group);
    }
    const allUsers: KeycloakUser[] = [];
    for (const property in props.users) {
        allUsers.push(props.users[property].user);
    }
    const filteredUserGroups = filterUserGroups(constellationFilters, searchInput.userGroups, allGroups);
    const table = convertKeycloakGroupToTable(filteredUserGroups, allUsers);

    // Functions
    const onSearchBarChange = function (input: string) {
        dispatch(FiltersActions.setSearchInput({ ...searchInput, userGroups: input }));
    };

    // Renders
    const insertBody = () => {
        if (allGroups.length > 0) {
            if (filteredUserGroups.length > 0) {
                return null;
            } else {
                return (
                    <div className="center-container">
                        <EmptyPlaceholder
                            img="./images/notFound.png"
                            title={"No Permission Sets Found"}
                            description={"Please refine your search/filter criteria and try again."}
                        />
                    </div>
                );
            }
        } else {
            return (
                <div className="center-container">
                    <EmptyPlaceholder
                        img="./images/notFound.png"
                        title={"No Permission Sets Available"}
                        description={"There are no available permission sets."}
                    />
                </div>
            );
        }
    };

    return (
        <div className="gcm-contents-wrapper">
            {allGroups.length > 0 && (
                <>
                    <div className="gcm-contents-header-wrapper">
                        <div className="gcm-contents-sub-header-wrapper gcm-contents-sub-header-priority-wrapper">
                            <UserfulSearchBar forceValue={searchInput.userGroups} onChange={onSearchBarChange} />
                        </div>
                        <div className="gcm-contents-sub-header-wrapper">
                            <GroupForm type={"PRIMARY"} permissions={permissions} />
                        </div>
                    </div>
                </>
            )}
            <div className="gcm-contents-body-wrapper">
                {allGroups.length === 0 && insertBody()}
                {allGroups.length > 0 && (
                    <ClickAndDragZone id={ZONE_ID}>
                        {filteredUserGroups.length > 0 ? (
                            <UserfulTable
                                table={table}
                                onRowSingleClick={(row) => {
                                    const id = (row as any)?.id as StringID;
                                    if (id) {
                                        dispatch(AppSliceActions.setAppView({ type: "USER_GROUP", id }));
                                    }
                                }}
                            />
                        ) : (
                            insertBody()
                        )}
                    </ClickAndDragZone>
                )}
            </div>
        </div>
    );
}
